import global from "@/global";
import { createResourceService } from "@/query//createResourceService";
import { Location } from "@/resources/types";

const { dataProvider, queryClient, client } = global;

export const locationService = createResourceService<Location>({
  resource: "locations",
  client,
  dataProvider,
  queryClient,
});